import React, {Component} from 'react';
import { Breadcrumb, Select, DatePicker, Button, message, Input } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import './UserAccessDashboard.css';
import UserAccessGrid from './UserAccessGrid';
import AddOrEditUserAccessModalDialog from './AddOrEditUserAccessModalDialog';
import DelUserAccessModalDialog from './DelUserAccessModalDialog';
import CopUserAccessModalDialog from './CopUserAccessModalDialog';
import OperationRecordDialog from '../../../common/operationRcd/components/OperationRecordDialog';


class UserAccessDashboard extends Component {
    componentDidMount() {
        const {
            cpty,
            functiontype,
            fundandcompany,
            userName,
            status
        } = this.props.userAccessQueryFields;
        this.props.loadUserAccessInfo({cpty: undefined,functiontype: undefined,fundandcompany: undefined,userName: undefined, status: 'Active'})

    }


    componentDidUpdate() {
        const {
            // query
            loadUserAccessInfoActionStatus,
            loadUserAccessInfoResp,
        } = this.props;

        if(loadUserAccessInfoActionStatus === ACTION_STATUS.SUCCESS) {
            this.props.initLoadUserAccessInfoActionStatus();
        }
        if(loadUserAccessInfoActionStatus === ACTION_STATUS.ERROR) {
            let err = 'Load User Access Info failed';
            if(!!loadUserAccessInfoResp && !!loadUserAccessInfoResp.respMessage) {
                err = loadUserAccessInfoResp.respMessage;
            }
            message.error(err);
            this.props.initLoadUserAccessInfoActionStatus();
        }

    }


    onInputChange = ({ name, value }) => {
        this.props.onQueryInputChange({ name, value });
    };

    batchReplace = (mode) => {
        if(mode === 'ADD') {
            this.props.openAddOrEditUserAccessModal(mode, null);
        } else {
            const {
                selectedUserAccessInfoArray,
            } = this.props;
            if(selectedUserAccessInfoArray.length === 0) {
                message.warning("Please choose one and  User Access Info");
                return;
            }
            const idList = selectedUserAccessInfoArray.map(e => e.id);
            // this.props.openAddOrEditPortfolioMonitoringRuleSubModal(mode, null,idList);
            const currentUserAccessInfo = selectedUserAccessInfoArray[0];
            const ids_str = idList.join(',');
            this.props.openDelUserAccessModal(currentUserAccessInfo,mode,ids_str);
            // this.props.openDelUserAccessModal(currentUserAccessInfo,mode);
        }
    }
    addOrEditBtnOnClicked = (mode) => {
        if(mode === 'ADD') {
            this.props.openAddOrEditUserAccessModal(mode, null);
        } else {
            const {
                selectedUserAccessInfoArray,
            } = this.props;
            if(selectedUserAccessInfoArray.length !== 1) {
                message.warning("Please choose one and only one User Access Info");
                return;
            }
            const currentUserAccessInfo = selectedUserAccessInfoArray[0];
            this.props.openAddOrEditUserAccessModal(mode, currentUserAccessInfo);
        }
    }
    copyAllBtnOnClicked = () => {
        const {
            selectedUserAccessInfoArray,
        } = this.props;
        if(selectedUserAccessInfoArray.length !== 1) {
            message.warning("Please choose one and only one User Access Info");
            return;
        }
        const currentUserAccessInfo = selectedUserAccessInfoArray[0];
        this.props.openCopUserAccessModal(currentUserAccessInfo);
    }

    delBtnOnClicked = (mode) => {
        const {
            selectedUserAccessInfoArray,
        } = this.props;
        if(selectedUserAccessInfoArray.length !== 1) {
            message.warning("Please choose one and only one User Access Info");
            return;
        }
        const currentUserAccessInfo = selectedUserAccessInfoArray[0];
        this.props.openDelUserAccessModal(currentUserAccessInfo,mode);
    }


    refreshBtnOnClicked = () => {
        const {
            cpty,
            functiontype,
            fundandcompany,
            userName,
            status
        } = this.props.userAccessQueryFields;
        this.props.loadUserAccessInfo({cpty,functiontype,fundandcompany,userName, status})
    }


    // 操作记录页面，自定义需要展示的列
    opRcdCustomColumns = ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'];

    operationRcdBtnOnClicked = () => {
        const { selectedUserAccessInfoArray } = this.props;
        const queryFields = { module: 'UserAccess' };

        if (selectedUserAccessInfoArray.length > 0) {
            queryFields.dataId = selectedUserAccessInfoArray.map(item => item.id).join(',');
        }

        this.props.doOperationRecordAction({
            action: 'OPEN_AND_QUERY',
            queryFields,
            customColumns: this.opRcdCustomColumns,
        });
    }


    render() {

        const {
            statusOptions,
            userAccountOptions,
            userAccessQueryFields,
            loadUserAccessInfoActionStatus,
        } = this.props;

        const {
            userName,
            status,
        } = userAccessQueryFields;


        const refreshBtnIsLoading = loadUserAccessInfoActionStatus === ACTION_STATUS.LOGINING;



        return (
            <div className='UserAccessWrapper'>
                <div className='breadcrumbWrapper'>
                    <Breadcrumb>
                        <Breadcrumb.Item>Entity & Account</Breadcrumb.Item>
                        <Breadcrumb.Item>User Access</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className='OperationBar'>
                <div className='breadcrumbWrapper'>   
                <Breadcrumb>
                <Breadcrumb.Item>  Search by:</Breadcrumb.Item>
                </Breadcrumb>
                </div>


                    <Input 
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        placeholder="Cpty"
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'cpty', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="Function"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'functiontype', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="Fund/Co."
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'fundandcompany', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="User"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'userName', value: event.target.value })
                        }} 
                    />
                    {/* <Select
                        allowClear
                        showSearch
                        size='small'
                        // --value={!user ? undefined : user}
                        style={{marginLeft: 10, width: 150}}
                        //onChange={(value) => this.onInputChange({name: 'userName', value: value})}
                        onChange={(val) => {
                            this.onInputChange({ name: 'userName', value: val })
                        }} 
                        placeholder="Employee">
                        {userAccountOptions}
                    </Select> */}
                    <Select
                        allowClear
                        size='small'
                        style={{ width: 150, marginLeft: 10 }}
                        onChange={(val) => {
                            this.onInputChange({ name: 'status', value: val })
                        }} 
                        placeholder="Status">
                        {statusOptions}
                    </Select>
                    {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date Start"
                      onChange={(invDateStart, dateString) => {
                        this.onInputChange({ name: 'invDateStart', value: dateString });
                      }}
                    /> */}
                    {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date End"
                      onChange={(invDateEnd, dateString) => {
                        this.onInputChange({ name: 'invDateEnd', value: dateString });
                      }}
                    /> */}
                    <Button 
                        onClick={this.refreshBtnOnClicked} 
                        loading={refreshBtnIsLoading}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'
                        icon="search" 
                    />
                    <Button 
                        onClick={()=>this.batchReplace('REPLACE')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        REPLACE
                    </Button>
                    <Button 
                        onClick={()=>this.addOrEditBtnOnClicked('ADD')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        Add
                    </Button>
                    <Button 
                        onClick={()=>this.addOrEditBtnOnClicked('COPY')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        Copy
                    </Button>
                    <Button 
                        onClick={()=>this.copyAllBtnOnClicked()} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        Copy All
                    </Button>
                    <Button 
                        onClick={()=>this.addOrEditBtnOnClicked('EDIT')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Edit
                    </Button>
                    <Button 
                        onClick={()=>this.delBtnOnClicked('inactive')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Inactivate User
                    </Button>
                    <Button 
                        onClick={()=>this.delBtnOnClicked('del')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='negative-button'>
                        Del
                    </Button>
                    <Button 
                        onClick={this.operationRcdBtnOnClicked}
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Operation Record
                    </Button>
                </div>

                <div className='UserAccessGrid'><UserAccessGrid {...this.props} /></div>
                <AddOrEditUserAccessModalDialog {...this.props} />
                <DelUserAccessModalDialog {...this.props} />
                <CopUserAccessModalDialog {...this.props} />
                <OperationRecordDialog {...this.props} />

            </div>
        );
    }
}

export default UserAccessDashboard;
